import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  { 
    path: "/",
    name: "home",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../views/Home.vue")
  },
  // 产品站动效路由-start
  { 
    path: "/ScrollScaleVideo",
    name: "index",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/ScrollScaleVideo")
  },{ 
    path: "/clipt",
    name: "clipt",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/clipt")
  },{ 
    path: "/scrollClip",
    name: "scrollClip",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollClip")
  },{ 
    path: "/scrollClipText",
    name: "scrollClipText",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollClipText")
  },{ 
    path: "/scrollCutting",
    name: "scrollCutting",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollCutting")
  },{ 
    path: "/scrollFrame",
    name: "scrollFrame",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollFrame")
  },{ 
    path: "/scrollChipVideo",
    name: "scrollChipVideo",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollChipVideo")
  },{ 
    path: "/scrollPencil",
    name: "scrollPencil",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollPencil")
  },{ 
    path: "/scrollText",
    name: "scrollText",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollText")
  },{ 
    path: "/textTransform",
    name: "textTransform",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/textTransform")
  },{ 
    path: "/scrollMask",
    name: "scroll遮罩",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollMask")
  },{ 
    path: "/scrollSwitch",
    name: "视频切换",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollSwitch")
  },{ 
    path: "/glass",
    name: "米家眼镜产品站动效",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/glass")
  },{ 
    path: "/scrollMaskOne",
    name: "scroll遮罩",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollMaskOne")
  },{ 
    path: "/scrollZoom",
    name: "控制图片变焦",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/scrollZoom")
  },{ 
    path: "/ipadmini",
    name: "ipadmini",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/ipadmini/index.vue")
  },{ 
    path: "/ipadmini2",
    name: "ipadmini2",
    meta: { title: "动效超市-产品站动效超市" },
    component: () => import("../product/ipadmini2")
  },
  // 产品站动效路由-end
  
  //公众号路由-start
  {
    path: "/gzh",
    name: "公众号",
    component: () => import("@/views/gzh/index.vue"),
    children:[
      {
        path: "",
        name: "公众号",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("@/views/_common/WeChatsList/index.vue"),
      },{
        path: "gzh220307",
        name: "gzh220307",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220307/index.vue"),
      },{
        path: "gzh220308",
        name: "gzh220308",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220308/index.vue"),
      },{
        path: "gzh220414",
        name: "gzh220414",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220414/index.vue"),
      },{
        path: "gzh220415",
        name: "gzh220415",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220415/index.vue"),
      },{
        path: "gzh220416",
        name: "gzh220416",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220416/index.vue"),
      },{
        path: "gzh220608",
        name: "gzh220608",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220608/index.vue"),
      },{
        path: "gzh220913",
        name: "gzh220913",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220913/index.vue"),
      },{
        path: "gzh220920",
        name: "gzh220920",
        meta: { title: "动效超市-公众号动效超市" },
        component: () => import("../wechat/gzh220920/index.vue"),
      }
    ]
  },
  //公众号路由-end
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title;
  next();
});

export default router;





// WEBPACK FOOTER //
// ./src/router/index.js